import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=773efdb8&"
import script from "./ProjectRow.vue?vue&type=script&lang=js&"
export * from "./ProjectRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports